class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this),
    );

    this.addEventListener("click", function (e) {
      const target = e.target.closest(".mobile-facets__dropdown-arrow");

      if (target) {
        const targetParentItem = e.target.closest(".mobile-facets__item");
        targetParentItem.classList.toggle("active");
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const facetDrawer = document.getElementById("FacetDrawer");
    const countContainer = document.getElementById("ProductCount");
    const countContainerMobile = document.getElementById("ProductCountMobile");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerMobile) {
      countContainerMobile.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }
    if (facetDrawer) {
      facetDrawer.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.manageAdBannersAndSubcategories();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.manageAdBannersAndSubcategories();
  }

  static renderProductGridContainer(html) {
    try {
      const container = document.getElementById("ProductGridContainer");
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const newGridContainer = parsed.getElementById("ProductGridContainer");

      if (container && newGridContainer) {
        container.innerHTML = newGridContainer.innerHTML;
      }

      const layoutSwitcher = document.querySelector("#FacetFiltersForm layout-switcher");
      if (layoutSwitcher) {
        layoutSwitcher.onButtonClick(
          layoutSwitcher.querySelector(".list-view__item--active")
        );
      }
    } catch (error) {
      console.warn("renderProductGridContainer failed:", error);
    }

    document
      .getElementById("ProductGridContainer")
      ?.querySelector(".collection")
      ?.classList.remove("loading");
  }


  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount")?.innerHTML;
    const container = document.getElementById("ProductCount");
    const containerMobile = document.getElementById("ProductCountMobile");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    if (count && container) {
      container.innerHTML = count;
      container.classList.remove("loading");
    }
    if (count && containerMobile) {
      containerMobile.innerHTML = count;
      containerMobile.classList.remove("loading");
    }
    if (count && containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );

    const facetDrawer = document.getElementById("FacetDrawer");
    if (facetDrawer) {
      facetDrawer.classList.remove("loading");
    }

    FacetFiltersForm.renderFilterCounts();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;

      document
        .querySelectorAll(".mobile-facets__sublist")
        .forEach(function (list) {
          let activeInputs = 0;

          list.querySelectorAll("input").forEach(function (input) {
            if (input.checked) {
              activeInputs = activeInputs + 1;
            }
          });
          if (activeInputs > 0) {
            document.querySelector(".active-facets").classList.remove("hidden");
          }
        });
    });
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".facets__open",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("facet-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }

  static renderFilterCounts() {
    const selectedFilters = document.querySelectorAll('.mobile-facets__list input[type="checkbox"]:checked');
    const totalFilterCountMarkers = document.querySelectorAll('[data-total-filter-count]');
    if (selectedFilters.length > 0) {
      document.querySelector('.mobile-facets__wrapper').classList.add('filter--selected');
    } else {
      document.querySelector('.mobile-facets__wrapper').classList.remove('filter--selected');
    }
    totalFilterCountMarkers.forEach(marker => {
      marker.innerHTML = selectedFilters.length > 0 ? `(${selectedFilters.length})` : '';
    });
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid")?.dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();

    document
      .querySelectorAll(".mobile-facets__sublist")
      .forEach(function (list) {
        let inputsCount = list.querySelectorAll("input").length;
        let activeInputs = 0;

        list.querySelectorAll("input").forEach(function (input) {
          if (input.checked) {
            activeInputs = activeInputs + 1;
          }
        });

        if (
          !event.target.classList.contains("mobile-facets__first-lv-checkbox")
        ) {
          if (inputsCount == activeInputs) {
            list.closest(".list-menu__item").querySelector("input").checked =
              true;
          } else {
            list.closest(".list-menu__item").querySelector("input").checked =
              false;
          }

          if (activeInputs > 0) {
            document.querySelector(".active-facets").classList.remove("hidden");
          }
        } else {
          let listSubItems = event.target
            .closest(".mobile-facets__item")
            .querySelector(".mobile-facets__list");

          if (event.target.checked == true) {
            listSubItems
              .querySelectorAll("input")
              .forEach((input) => (input.checked = true));
          } else {
            listSubItems
              .querySelectorAll("input")
              .forEach((input) => (input.checked = false));
          }
        }
      });

    const form = event.target.closest("form");
    const formData = new FormData(form);

    // Acquire current URL parameters
    const currentParams = new URLSearchParams(window.location.search);

    // Collect all field names from the current form
    const keysInForm = new Set();
    for (const [key] of formData.entries()) {
      keysInForm.add(key);
    }

    // Remove existing parameters in the URL that match the form's field names
    keysInForm.forEach((key) => {
      currentParams.delete(key);
    });

    // Append all form data to the currentParams
    for (const [key, value] of formData.entries()) {
      currentParams.append(key, value);
    }

    // Render the page
    FacetFiltersForm.renderPage(currentParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.renderPage(
      new URL(event.currentTarget.href).searchParams.toString(),
    );
  }

  static manageAdBannersAndSubcategories() {
    let ads = window.ad_banners;
    let grid = document.getElementById('product-grid');
    let showAds = true;

    // Hides ads if filters are selected. Comparing the length with 2 considering availabiity filter by default
    if(document.querySelectorAll('.active-facets-mobile facet-remove')?.length > 1 || ads?.length <= 0){
      showAds = false;
    }

    if(ads && ads.length <= 0){
      showAds = false;
    }

    if(ads && showAds) {
      ads.forEach((ad) => {
        const newAdLi = document.createElement('li');
        const position = parseInt(ad.position - 1);
        let style = `--heading-color: ${ad.heading_color}; --heading-color-mobile: ${ad.heading_color_mobile};
        --cta-color: ${ad.cta_color}; --cta-color-mobile: ${ad.cta_color_mobile};`
        newAdLi.setAttribute('id', ad.identifier);
        newAdLi.classList.add('grid__item', 'marketing-ad--banner');
        newAdLi.innerHTML = `<div class="media marketing-ad__media small-hide">${ad.desktop_image}</div>
        <div class="media marketing-ad__media medium-hide large-up-hide">${ad.mobile_image}</div>
        <div class="marketing-ad__content position--${ad.content_position } position--${ad.content_position_mobile }-mobile alignment--${ad.content_alignment } alignment--${ad.content_alignment_mobile }-mobile" style="${style}">
          <h3>${ad.heading}</h3>
          <a href="${ad.cta_link}" class="link">${ad.cta_text}</a>
        </div>`;

        //if ad position is greater than item count in grid, do not show ad
        if(!(position > grid.querySelectorAll('li.grid__item:not(.marketing-ad--banner)').length)){
          grid.insertBefore(newAdLi, grid.querySelectorAll('li.grid__item:not(.marketing-ad--banner)')[position]);
        }
      })
    }

    // Subcategories show/hide

  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.manageAdBannersAndSubcategories();

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define("facet-remove", FacetRemove);

class FacetToggle extends HTMLElement {
  constructor() {
    super();

    const attributes = {
      expanded: "aria-expanded",
    };

    this.addEventListener("click", () => {
      const details = this.closest("details");
      details.setAttribute(
        attributes.expanded,
        (details.getAttribute(attributes.expanded) === "false").toString(),
      );
    });
  }
}
customElements.define("facet-toggle", FacetToggle);

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.min = Number(this.dataset.min);
    this.max = Number(this.dataset.max);
    this.track = this.querySelector(".price-range__track");
    this.handles = [...this.querySelectorAll(".price-range__thumbs")];
    this.startPos = 0;
    this.activeHandle;

    this.handles.forEach((handle) => {
      handle.addEventListener("mousedown", this.startMove.bind(this));
    });

    window.addEventListener("mouseup", this.stopMove.bind(this));

    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  startMove(e) {
    this.startPos = e.offsetX;
    this.activeHandle = e.target;
    this.moveListener = this.move.bind(this);
    window.addEventListener("mousemove", this.moveListener);
  }

  move(e) {
    const isLower = this.activeHandle.classList.contains("is-lower");
    const property = isLower ? "--progress-lower" : "--progress-upper";
    const parentRect = this.track.getBoundingClientRect();
    const handleRect = this.activeHandle.getBoundingClientRect();
    let newX = e.clientX - parentRect.x - this.startPos;

    if (isLower) {
      const otherX = parseInt(this.style.getPropertyValue("--progress-upper"));
      const percentageX = (otherX * parentRect.width) / 100;
      newX = Math.min(newX, percentageX - handleRect.width);
      newX = Math.max(newX, 0 - handleRect.width / 2);
    } else {
      const otherX = parseInt(this.style.getPropertyValue("--progress-lower"));
      const percentageX = (otherX * parentRect.width) / 100;
      newX = Math.max(newX, percentageX);
      newX = Math.min(newX, parentRect.width - handleRect.width / 2);
    }

    const percentage = (newX + handleRect.width / 2) / parentRect.width;
    const valuenow = this.calcHandleValue(percentage);
    this.style.setProperty(property, percentage * 100 + "%");
    this.activeHandle.ariaValueNow = valuenow;

    const output = this.activeHandle.nextElementSibling;
    const text = output.querySelector(".price-range__output-text");
    text.innerHTML = valuenow;

    const inputs = this.querySelectorAll("input");
    const input = isLower ? inputs[0] : inputs[1];
    input.value = valuenow;

    this.adjustToValidValues(input);
    this.setMinAndMaxValues();
  }

  calcHandleValue(percentage) {
    return Math.round(percentage * (this.max - this.min) + this.min);
  }

  stopMove() {
    window.removeEventListener("mousemove", this.moveListener);
    const form = this.closest("form");

    if (this.activeHandle && form) form.dispatchEvent(new Event("input"));
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define("price-range", PriceRange);

class LayoutSwitcher extends HTMLElement {
  constructor() {
    super();

    this.cookieName = "beyours:collection-layout";

    this.initLayoutMode();
    this.querySelectorAll(".list-view__item").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    const target = event.target ? event.target : event;
    this.changeLayoutMode(target, target.dataset.layoutMode);
  }

  initLayoutMode() {
    if (isStorageSupported("local")) {
      const layoutMode = window.localStorage.getItem(this.cookieName);

      if (layoutMode !== null) {
        const target = this.querySelector(
          `.list-view__item[data-layout-mode="${layoutMode}"]`,
        );

        if (target) {
          this.changeLayoutMode(target, layoutMode);
        }
      }
    }
  }

  changeLayoutMode(target, layoutMode) {
    const productGrid = document.getElementById("product-grid");

    if (productGrid.classList.contains("collection--empty")) {
      return;
    }

    const removedClass = [
      "list",
      "grid",
      "grid--1-col",
      "grid--2-col",
      "grid--3-col-tablet",
      "grid--2-col-desktop",
      "grid--3-col-desktop",
      "grid--4-col-desktop",
    ];
    removedClass.forEach((removed) => {
      productGrid.classList.remove(removed);
    });

    let addedClass = [];
    switch (layoutMode) {
      case "list":
        addedClass = ["grid", "grid--1-col", "grid--2-col-desktop", "list"];
        break;

      case "grid-2":
        addedClass = ["grid", "grid--2-col"];
        break;

      case "grid-3":
        addedClass = [
          "grid",
          "grid--2-col",
          "grid--3-col-tablet",
          "grid--3-col-desktop",
        ];
        break;

      case "grid-4":
        addedClass = [
          "grid",
          "grid--2-col",
          "grid--3-col-tablet",
          "grid--4-col-desktop",
        ];
        break;
    }
    addedClass.forEach((added) => {
      productGrid.classList.add(added);
    });

    this.querySelectorAll(".list-view__item").forEach((button) =>
      button.classList.remove("list-view__item--active"),
    );

    target.classList.add("list-view__item--active");

    if (isStorageSupported("local")) {
      window.localStorage.setItem(this.cookieName, layoutMode);
    }
  }
}
customElements.define("layout-switcher", LayoutSwitcher);

class StickyFacetFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener("scroll", this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= this.parentNode.offsetTop) {
      requestAnimationFrame(this.reveal.bind(this));
    } else {
      requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    this.classList.add("shopify-section-filters-sticky");
  }

  reset() {
    this.classList.remove("shopify-section-filters-sticky");
  }
}
customElements.define("sticky-facet-filters", StickyFacetFilters);

if (window.performance.navigation.type == 1) {
  FacetFiltersForm.updateURLHash("");
  FacetFiltersForm.renderPage("", null, false);
}
